import { FC } from "react";
import Avatar from "Components/Avatar";
import DateTime from "Components/DateTime";
import { CommentWrapper, Grid } from "./Comment.styled";
import CommentActions from "./CommentActions";

interface Props {
  comment: {
    body: string;
    author: string;
    timestamp: number;
    id: string;
    flag?: string;
    users_flagged?: string[];
  };
  userId: string;
}

const Comment: FC<Props> = ({ comment }) => {
  const { body, author, timestamp } = comment;
  return (
    <CommentWrapper>
      <Grid>
        <Avatar
          user={author ? (author.charAt(0) ? author.charAt(0) : "U") : "U"}
        />
        <div>
          By <span className="author">{author}</span>
          <DateTime time={new Date(timestamp)} />
          <p>{body}</p>
        </div>
      </Grid>
      <CommentActions comment={comment} />
    </CommentWrapper>
  );
};

export default Comment;
